import {requestTimeout, handleResponse} from '../utils'
// import { Cookies } from 'react-cookie'

const apiUrl = process.env.REACT_APP_API_URL
// const accessToken = process.env.REACT_APP_ACCESS_TOKEN
const apiMaxTime = process.env.REACT_APP_API_EXEC_TIME

// const cookie = new Cookies();

export const discountApi = {
    _check,
    _get,
    
    
};


async function _check(data) {    

    const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE)
    const requestOptions = {
        method: 'POST',
        credentials: "include",
        headers: {
            'Authorization': 'Bearer '+ token,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify(data)
    };
    return requestTimeout(apiMaxTime,fetch(apiUrl + 'discounts', requestOptions))
                .then(handleResponse)
                .then((response) => {                    
                    return response
                });
    
}


async function _get() {

   
    const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE)
    const requestOptions = {
        method: 'GET',
        credentials: "include",
        headers: {
            'Authorization': 'Bearer '+ token,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }
    };
    return requestTimeout(apiMaxTime,fetch(apiUrl + 'discounts', requestOptions))                    
                .then(handleResponse)
                .then((response) => {    
                    return response
                })                
        
}

